import script from "./AdministratorProjectFormRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormRow.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormRow.vue?vue&type=style&index=0&id=59c8f76f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59c8f76f"]])

export default __exports__